import React, { useEffect, useRef } from 'react';
import '../styles/Input.css';
import { Arrow, Info } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { IconButton } from './';

function Input(props) {
    const darkMode = props.darkMode || false;
    const label = props.label;
    const labelType = props.labelType;
    const info = props.info;
    const onMouseEnter = props.onMouseEnter;
    const onMouseLeave = props.onMouseLeave;
    const labelStyle = labelType === "default" && darkMode === true ? "body-bold colour-white" : labelType === "default" ? "body-bold colour-primary" : "label-bold colour-primary";
    const value = props.value;
    const onChange = props.onChange;
    const placeholder = props.placeholder;
    const type = props.type;
    const leftUnit = props.leftUnit;
    const rightUnit = props.rightUnit;
    const unitSwitch = props.unitSwitch;
    const leftUnitSelected = props.leftUnitSelected;
    const unitSwitchFunc = props.unitSwitchFunc;
    const disabled = props.disabled;
    const multiline = props.multiline;
    const error = props.error;
    const reset = props.reset;
    const resetFunc = props.resetFunc;
    const resetPosition = props.resetPosition;
    const secondaryLabel = props.secondaryLabel;
    const secondaryLabelGrey = props.secondaryLabelGrey;
    const focusMultiline = props.focusMultiline;
    const prompt = props.prompt;
    const submitPromptDisabled = props.submitPromptDisabled;
    const submitPrompt = props.submitPrompt;
    const onHeightChange = props.onHeightChange;
    const textareaRef = useRef(null);

    // Ensure text remains selected on focus
    useEffect(() => {
        if (focusMultiline && textareaRef.current) {
            textareaRef.current.focus();
            textareaRef.current.select();
        }
    }, [focusMultiline]);


    return (
        <div className={"input-container " + (darkMode === true ? "input-dark " : "") + (error === true ? "input-error " : "") + (labelType === null || labelType === "inside" ? "" : labelType === "default" ? "gap-small" : "gap-x-small")}>
            {
                labelType === null || labelType === "inside" ?
                null
                :
                <div className={"relative-container " + (info === true ? "input-label-container " : secondaryLabelGrey !== undefined && secondaryLabelGrey !== null ? "input-secondary-label-container " : " ") + (info === false ? "" : labelType === "default" ? "gap-x-small" : "gap-x-x-small")}>
                    <label className={labelStyle}>
                        {label}{
                            secondaryLabel !== undefined && secondaryLabel !== null &&
                            <span className="body-regular colour-primary">
                                {" "}{secondaryLabel}
                            </span>
                        }
                    </label>
                    {
                        info === true &&
                        <Info
                            fill={colour.gray05}
                            className="cursor-pointer"
                            onMouseEnter={() => onMouseEnter()}
                            onMouseLeave={() => onMouseLeave()}
                        />
                    }
                    {
                        secondaryLabelGrey !== undefined && secondaryLabelGrey !== null &&
                        <span className="body-regular colour-secondary">
                            {secondaryLabelGrey}
                        </span>
                    }
                </div>
            }
            <div className={resetPosition === "default" ? "input-outer-wrapper-row " : "input-outer-wrapper-column " + (prompt === true ? "relative-container prompt-input-wrapper" : "")}>
                <div className={"input-wrapper " + (disabled === true ? "disabled " : "")}>
                    {
                        labelType !== "inside" ?
                        null
                        :
                        <div className={"input-label-container input-label-inside-container gap-x-small" }>
                            <label className={labelStyle}>
                                {label}
                            </label>
                        </div>
                    }
                    <div className="input-inner-wrapper">
                        {
                            leftUnit === null ?
                            null
                            :
                            <span 
                                className={"body-regular cursor-pointer " + (leftUnitSelected === true ? "colour-primary " : "colour-tertiary ") + (disabled === true ? "disabled" : "colour-primary-hover")}
                                onClick={() => (unitSwitch === false || disabled === true) ? null : unitSwitchFunc(false)}
                            >
                                {leftUnit}
                            </span>
                        }
                        {
                            prompt === true && multiline === true ?
                            <textarea
                                ref={textareaRef}
                                value={value}
                                onChange={onChange}
                                className={"input body-regular no-resize colour-primary " + (disabled === true ? "disabled" : "")}
                                placeholder={placeholder}
                                onInput={(e) => {
                                    e.target.style.height = "auto";
                                    e.target.style.height = e.target.scrollHeight + "px";
                                    if (onHeightChange) {
                                        onHeightChange(e.target.scrollHeight);
                                    }
                                }}
                                rows={1}  
                                disabled={disabled}
                                onFocus={focusMultiline ? (e) => setTimeout(() => e.target.select(), 0) : null}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && !e.shiftKey) {
                                        if (value.trim() !== "") {
                                            e.preventDefault(); // Prevent new line
                                            submitPrompt(); // Call the submit function
                                        }
                                    }
                                }}
                            />
                            :
                            multiline === true ?
                            <textarea
                                ref={textareaRef}
                                value={value}
                                onChange={onChange}
                                className={"input body-regular colour-primary " + (disabled === true ? "disabled" : "")}
                                placeholder={placeholder}
                                rows={6}
                                disabled={disabled}
                                onFocus={focusMultiline ? (e) => setTimeout(() => e.target.select(), 0) : null}
                            />
                            :
                            <input
                                type={type}
                                value={value}
                                onChange={onChange}
                                className={"input body-regular colour-primary " + (leftUnitSelected === true ? "text-align-left " : "text-align-right ") + (disabled === true ? "disabled" : "")}
                                placeholder={placeholder}
                                disabled={disabled}
                            />
                        }
                        {
                            rightUnit === null ?
                            null
                            :
                            <span 
                                className={"body-regular cursor-pointer " + (leftUnitSelected === false || unitSwitch === false ? "colour-primary " : "colour-tertiary ") + (disabled === true ? "disabled" : "colour-primary-hover")}
                                onClick={() => (unitSwitch === false || disabled === true) ? null : unitSwitchFunc(true)}
                            >
                                {rightUnit}
                            </span>
                        }
                    </div>
                    {
                        prompt === true &&
                        <IconButton
                            size="x-small"
                            icon={<Arrow className="rotate-90 input-prompt-arrow" fill={colour.gray00} />}
                            disabled={submitPromptDisabled}
                            clickFunc={() => submitPrompt()}
                            standardIcon={false}
                            background={true}
                            bgType={"dark"}
                            contextTooltip={false}
                            contextTooltipBG={null}
                            contextTooltipText={null}
                            customClass={null}
                        />
                    }
                </div>
                {
                    reset === true &&
                    <span 
                        className="body-regular-underline colour-link input-reset-element"
                        onClick={() => resetFunc()}
                    >
                        Reset
                    </span>
                }
            </div>
        </div>
    )
};

export default Input;